export const pluralize = (word: string, count: number, includeCount = false) => {
  const text = count > 1 ? `${word}s` : word;
  return includeCount ? `${count} ${text}` : text;
};
